import { privateAxios } from "../../../config/apiConfig";
import {
  CREATE_COLOR_FAILURE,
  CREATE_COLOR_REQUEST,
  GET_ALL_COLOR_SUCCESS,
  GET_ALL_COLOR_REQUEST,
  GET_ALL_COLOR_FAILURE,
  DELETE_COLOR_REQUEST,
  DELETE_COLOR_FAILURE,
  UPDATE_COLOR_REQUEST,
  UPDATE_COLOR_FAILURE,
  DELETE_COLOR_SUCCESS,
} from "./ActionType";
import { toast } from "react-toastify";

export const getAllColor = () => async (dispatch) => {
  dispatch({ type: GET_ALL_COLOR_REQUEST });
  try {
    const { data } = await privateAxios.get(`admin/colors`);
    dispatch({ type: GET_ALL_COLOR_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_COLOR_FAILURE, payload: error.message });
  }
};

export const createColor = (colorData) => async (dispatch) => {
  dispatch({ type: CREATE_COLOR_REQUEST });
  try {
    const { data } = await privateAxios.post(`admin/color`, colorData);
    if (data.status === "SUCCESS") {
      dispatch(getAllColor());
      toast.success(data.response);
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: CREATE_COLOR_FAILURE, payload: error.message });
  }
};

export const updateColor = (colorId, colorData) => async (dispatch) => {
  dispatch({ type: UPDATE_COLOR_REQUEST });
  try {
    const { data } = await privateAxios.put(
      `admin/color/${colorId}`,
      colorData
    );
    if (data.status === "SUCCESS") {
      dispatch(getAllColor());
      toast.success("Color Updated Successfully");
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: UPDATE_COLOR_FAILURE, payload: error.message });
  }
};

export const deleteColor = (colorId) => async (dispatch) => {
  dispatch({ type: DELETE_COLOR_REQUEST });
  try {
    const { data } = await privateAxios.delete(`admin/color/${colorId}`);
    if (data.status === "SUCCESS") {
      dispatch({ type: DELETE_COLOR_SUCCESS, payload: colorId })
      dispatch(getAllColor());
      toast.success(data.response);
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: DELETE_COLOR_FAILURE, payload: error.message });
  }
};
